import type { Advisor } from '../../types/portal'

/**
 * Selector de asesor para «Reasignar». Muestra la carga para elegir con
 * criterio.
 *
 * Vivía dentro de En vivo. Desde el 28-set-2026 lo usa también la bandeja de
 * supervisión y de Admin: quien intervino y ya contestó tiene que poder
 * salirse, y hasta entonces la única salida era «Marcar resuelta», que cierra
 * el caso. Uno solo para las dos pantallas: dos copias se comportan distinto en
 * cuanto una cambie.
 *
 * `onCola` agrega «Devolver a la cola»: salirse sin elegir a nadie. La
 * conversación queda sin asesor y, si la estaba atendiendo una persona, entra a
 * la cola global con el reloj en cero —lo resuelve el backend—.
 */
export default function SelectorAsesor({ advisors, actual, busy, onElegir, onCancelar, onCola }: {
  advisors: Advisor[]
  actual: string | null
  busy: boolean
  onElegir: (email: string) => void
  onCancelar: () => void
  onCola?: () => void
}) {
  const disponibles = advisors.filter((a) => a.email !== actual)
  return (
    <div className="shrink-0 border-t border-surface-border bg-surface px-[18px] py-3">
      <div className="flex items-center justify-between">
        <p className="text-body font-bold text-ink">Reasignar a</p>
        <button onClick={onCancelar} className="text-micro font-bold text-ink-muted">
          Cancelar
        </button>
      </div>
      {disponibles.length === 0 ? (
        <p className="mt-2 text-micro text-ink-faint">
          No hay otro asesor en el grupo Asesor.
        </p>
      ) : (
        <div className="mt-2 flex flex-wrap gap-2">
          {disponibles.map((a) => (
            <button
              key={a.email}
              disabled={busy}
              onClick={() => onElegir(a.email)}
              className="btn-row disabled:opacity-50"
              title={a.available
                ? `${a.active_conversations} activas · ${a.rotation_position}º en la rotación`
                : 'En pausa: no está recibiendo asignaciones'}
            >
              {a.name}
              <span className="font-mono text-[10px] text-ink-faint">
                {a.available ? `${a.active_conversations}` : 'pausa'}
              </span>
            </button>
          ))}
        </div>
      )}
      {onCola && (
        <div className="mt-2.5 flex items-center gap-2 border-t border-surface-faint pt-2.5">
          <button onClick={onCola} disabled={busy} className="btn-row disabled:opacity-50">
            Devolver a la cola
          </button>
          <span className="text-micro text-ink-faint">
            Sin elegir a nadie: la toma el próximo asesor desde la cola global.
          </span>
        </div>
      )}
    </div>
  )
}
